import React from 'react';
import MediaQuery from 'react-responsive';
import BeliefStatements from 'components/organisms/beliefStatements';
import BeliefStatementsMobile from 'components/organisms/beliefStatementsMobile';

const BeliefStatementsSection = props => {
  const { type } = props.data;
  return (
    <div id={props.origin === 'campaign' ? 'campaign' : 'our-values'}>
      <MediaQuery maxDeviceWidth={575.6}>
        <BeliefStatementsMobile
          data={props.mobileBannerData.cmsMobilePageData}
          cardData={props.mobileBannerData.upcomingShows}
          origin={props.origin}
        />
      </MediaQuery>
      <MediaQuery minDeviceWidth={576}>
        <BeliefStatements
          data={props.data.cmsPageData}
          cardData={props.data.upcomingShows}
          campaignId={props.data.campaignId}
          type={type}
        />
      </MediaQuery>
    </div>
  );
};

export default BeliefStatementsSection;
